var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdtGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_728_34897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5C7.16384 0.5 0 7.66384 0 16.5C0 25.3362 7.16416 32.5 16 32.5C24.8358 32.5 32 25.3381 32 16.5C32 7.66192 24.8371 0.5 16 0.5Z",
    fill: "#53AE94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0253 14.3682V11.988H8.58245V8.36145H23.4036V11.988H17.96V14.3663C22.384 14.5694 25.7104 15.4456 25.7104 16.4952C25.7104 17.5448 22.3824 18.421 17.96 18.6254V26.2494H14.024V18.6248C9.60805 18.421 6.28837 17.5454 6.28837 16.4968C6.28837 15.4482 9.60805 14.5726 14.024 14.3688M14.024 17.979V17.9771C14.1351 17.9842 14.7056 18.0184 15.976 18.0184C16.9917 18.0184 17.7063 17.9896 17.9581 17.9765V17.9797C21.8666 17.8066 24.784 17.1259 24.784 16.3115C24.784 15.4971 21.8663 14.8175 17.9581 14.644V17.3016C17.7021 17.3192 16.97 17.3624 15.9594 17.3624C14.7457 17.3624 14.1354 17.3118 14.0234 17.3016V14.644C10.1226 14.8178 7.21189 15.499 7.21189 16.3106C7.21189 17.1221 10.1239 17.8037 14.0234 17.9774",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_34897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(-1 0 0 1 32 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtGreen);
export default __webpack_public_path__ + "static/media/usdt-green.6ae6a1d6177f31e651df3768d95159c6.svg";
export { ForwardRef as ReactComponent };